import React, { useEffect, useState } from 'react';
import { MdAddCircleOutline } from 'react-icons/md';
import { MdCheck } from "react-icons/md";

const ClaimList = ({ setLongClaimList, claimed, longClaimList, winner, block, setOpenSnackBar, setErrorMsg }) => {
    const [toggleState, setToggleState] = useState(false);

    function toggle(to) {
        if (longClaimList.length > 199) {
            setOpenSnackBar(true);
            setErrorMsg('Max claimable list length exceeded!!');
            return;
        }
        switch (to) {
            case true:
                if (longClaimList.includes(block)) return;
                setLongClaimList(prev => [...prev, block]);
                break;
            case false:
                if (longClaimList.includes(block)) setLongClaimList(prev => prev.filter(item => item !== block));
                break;
        }
    };

    useEffect(() => {
        setToggleState(longClaimList.includes(block));
    }, [block])

    useEffect(() => {
        setToggleState(longClaimList.includes(block));
    }, [longClaimList])

    return (
        <div>
            {((claimed === false && winner === true) && !toggleState) && <MdAddCircleOutline onClick={() => toggle(true)} />}
            {((claimed === false && winner === true) && toggleState) && <MdCheck onClick={() => toggle(false)} />}
        </div>
    );
};

export default ClaimList;